import React, { useState } from 'react'
import styled from 'styled-components'
import Link from 'components/link'
import { BodyScrollLock } from 'components/styled'
import PageContainer from 'components/pageContainer'
import { MEDIA, PAGE_URL } from 'utils'

// Media query
const { MOBILE } = MEDIA

const TextContainer = styled(PageContainer)`
  @media screen and ${MOBILE} {
    margin: 0 20px;
  }
`
const TableContainer = styled(TextContainer)`
  position:relative;
`

const Title = styled.div`
  color: var(--cobasi-blue);
  font-size: 26px;
  font-weight: bold;
  font-family: var(--primary-font);
  text-align: center;
  margin: 3px;
`

const Subtitle = styled(Title)`
  font-size: 22px;
  line-height: 27px;
  margin: 0 0 35px;
`
const TitleTable = styled.div`
  color: var(--cobasi-blue);
  font-size: 22px;
  font-weight: bold;
  font-family: var(--primary-font);
  text-align: center;
  margin: 0 0 30px 0;
  border-bottom:3px solid var(--cobasi-blue);
  padding-bottom:15px;
  line-height:24px;
`

const Content = styled.section`
  font-size: 16px;
  font-weight: 600;
  font-family: var(--primary-font);
  line-height: 1.5;

  p {
    margin: 20px 0;
  }

  a {
    color: var(--cobasi-blue);
  }

`
const BoxImage = styled.div`
  margin-bottom:48px;

  @media screen and (max-width:1024px) {
    margin-bottom:30px;
    background:var(--cobasi-blue);

    ${props =>
      props.expand && `
        width:100%;
        height:100vh;
        overflow:auto;
        position:fixed;
        top:0;
        left:0;
        right:0;
        bottom:0;
        z-index:998;`
    }

    > img{
      ${props => props.expand ? 'opacity:1;' : 'opacity:0.6;'}
    }

  }
`

const BrMobile = styled.br`
  display:none;
  @media screen and ${MOBILE} {
    display:block;
  }
`

const ButtonExpandTable = styled.button`
  display:none;
  background:none;
  border:none;
  position:absolute;
  z-index:3;

  @media screen and (max-width:1024px) {
    display:block;
    ${props => props.expand ? `
      top:-80px;
      left:-80px;
      z-index:999;
      position:fixed;
    ` : `
      top:150px;
      left:calc(50% - 45px);
    `}
  }
`

const RegrasDeServicos = () => {
  const [expandMobile, setExpandMobile] = useState(false)

  const handleExpandImg = () => {
    setExpandMobile(!expandMobile)
  }

  return (
    <>
      <PageContainer maxWidth='866px' backPosition='absolute'>
        <Title>Regras de Serviços</Title>
        <Subtitle>Consulte abaixo as regras de serviços por parceiro:</Subtitle>
        <Content>
          <p>O prazo de tolerância de espera por parte do profissional é de até 10 minutos após o horário agendado.</p>
          <p>Em caso de desistência ou necessidade de remarcação, pedimos comunicar com antecedência mínima de 24 horas via Whatsapp (11) 95961-3784.</p>
          <p>Sugerimos conversar com o profissional, antes do início do serviço, para instruções sobre o atendimento.</p>
          <p>Serviços adicionais não foram incluídos nesta solicitação de agenda.</p>
          <p>Serviços adicionais como corte de unha, hidratação, desembolo de pelos, e outros, poderão ser contratados diretamente no local.</p>
          <p>Serviços adicionais somente poderão ser incluídos, no ato do serviço, após avaliação do profissional e disponibilidade de tempo para execução.</p>
          <p>Os valores deverão ser pagos no endereço agendado, onde será realizado o serviço.</p>
          <p>Os valores poderão sofre alteração de acordo com o tipo de raça e o tamanho do Pet (nos casos de SRD - sem raça definida).</p>
          <p>Os valores poderão sofrer alteração caso seja incluído algum serviço adicional no ato da entrega do Pet para o Profissional.</p>
          <p>Alguns serviços específicos não serão realizados aos finais de semana e feriados. Em caso de agendas fora dessas regras, a recepção entrará em contato para efetuar remarcação.</p>
          <p>Para mais informações acesse <Link href={PAGE_URL.SERVICE_TERMS}><a>Política de Uso</a></Link></p>
        </Content>
      </PageContainer>
      <TableContainer maxWidth='1087px'>
        <TitleTable>Confira tabela de exceções<BrMobile /> de prestação de serviços</TitleTable>
        <ButtonExpandTable expand={expandMobile} onClick={handleExpandImg}><img src={!expandMobile ? 'static/images/expand-icon.svg' : 'static/images/back-icon.png'} alt={!expandMobile ? 'Expandir' : 'Comprimir'} /></ButtonExpandTable>
        <BoxImage expand={expandMobile}>
          <img width='100%' src='static/images/tabela-regrasdeservicos.png' alt='Tabela de Regras de Serviços' />
        </BoxImage>
      </TableContainer>
      <BodyScrollLock active={expandMobile} />
    </>
  )
}

export default RegrasDeServicos
